import { render, staticRenderFns } from "./CoinPrice.vue?vue&type=template&id=aeb0a1ee&scoped=true&"
import script from "./CoinPrice.vue?vue&type=script&lang=js&"
export * from "./CoinPrice.vue?vue&type=script&lang=js&"
import style0 from "./CoinPrice.vue?vue&type=style&index=0&id=aeb0a1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb0a1ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAutocomplete,VCard,VCardText})
